<script setup>
import { computed, ref, watch } from 'vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  tabs: {
    type: Array,
    default: () => [],
  },
  styleNav: {
    type: String,
    default: "nav-tabs"
  },
  size: {
    type: String,
    default: "md",
  },
  refined: {
    type: Boolean,
    default: false,
  },
  fullWidth: {
    type: Boolean,
    default: false,
  },
});

const localValue = ref(props.modelValue);
const navClasses = computed(() => [
  props.styleNav,
  `tabs-bootstrap--${props.size}`,
  {
    "tabs-bootstrap--refined": props.refined,
    "tabs-bootstrap--full-width": props.fullWidth,
  },
]);

function setActiveTab(tab) {
  localValue.value = tab;
  emit('update:modelValue', tab);
}

watch(
  () => props.modelValue,
  (newVal) => {
    localValue.value = newVal;
  }
);
</script>

<template>
  <ul class="nav mb-2 tabs-bootstrap" :class="navClasses">
    <li v-for="(tab, index) in tabs" :key="index" class="nav-item">
      <button
        type="button"
        class="nav-link"
        :class="{ active: localValue === tab.value }"
        @click="setActiveTab(tab.value)"
      >
        {{ tab.label }}
      </button>
    </li>
  </ul>
</template>

<style scoped>
.tabs-bootstrap .nav-link {
  background: transparent;
  border: 0;
  box-shadow: none;
}

.tabs-bootstrap--full-width {
  display: flex;
}

.tabs-bootstrap--full-width .nav-item {
  flex: 1 1 0;
}

.tabs-bootstrap--full-width .nav-link {
  width: 100%;
}

.tabs-bootstrap--sm .nav-link {
  font-size: 0.8125rem;
  padding: 0.4rem 0.65rem;
}

.nav-underline .nav-link.active {
  border-bottom-color: var(--bs-primary) !important;
}

.nav-underline.tabs-bootstrap--refined {
  gap: 1rem;
}

.nav-underline.tabs-bootstrap--refined .nav-link {
  border-bottom: 1px solid rgba(108, 117, 125, 0.22);
  border-radius: 0;
  color: #8f99aa;
  font-weight: 500;
  margin-bottom: 0;
  padding-left: 0.45rem;
  padding-right: 0.45rem;
  transition: color 0.15s ease,
    border-color 0.15s ease;
}

.nav-underline.tabs-bootstrap--refined .nav-link:hover {
  background: transparent;
  color: #677387;
}

.nav-underline.tabs-bootstrap--refined .nav-link.active {
  background: transparent;
  border-bottom-color: var(--bs-primary) !important;
  color: #344767 !important;
  font-weight: 500;
}
</style>
